export const clearButtonSelection = {
  color: 'grey.600',
  border: 'none',
  ':hover': {
    backgroundColor: 'grey.300',
    border: 'none',
  },
  padding: '6px 12px',
};
